/**
 * Single source of truth for excluded accounts.
 *
 * Loads the list from reference-data/excluded-accounts.json and exposes
 * both a Set (fast membership check) and the raw records (for UI/reasons).
 *
 * To add a new exclusion: edit reference-data/excluded-accounts.json.
 */
import records from '../../reference-data/excluded-accounts.json';

export const EXCLUDED_ACCOUNT_RECORDS = records;

export const EXCLUDED_ACCOUNTS = new Set(
  records.map((r) => String(r.account_no).trim())
);
